import { createContext, useContext } from "react";

export const LoaderContext = createContext({
  loading: false,
  setLoader: () => {},
});
export const useLoaderContext = () => useContext(LoaderContext);
